import { useSearchParams } from 'next/navigation'
import { FC } from 'react'

import { TypeStyle } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { SizeChartModalService } from '../../../../brunswick/containers/SizeChartModalService'
import { trackEvent } from '../../../../lib/analytics'
import { ProductWithAvailability } from '../../../../types/graphql'
import { bulkOrderCategory } from '../constants'

import { CategoryProductTile } from './CategoryProductTile'
import { Body, HeaderWrapper, SizeChartButton, TilesList } from './styles'

type Props = {
  name: string
  headline: string
  products: Array<ProductWithAvailability> | undefined
}

export const CategoryProductSection: FC<Props> = ({ name, headline, products }: Props) => {
  const { openSizeChartModal } = SizeChartModalService.useContainer()
  // plain=true query param is used by iOS app to view webpages within a webview without the website's header/footer
  const isPlain = useSearchParams()?.get('plain') === 'true'
  const {
    sizesSection: {
      sizeChart: { headline: sizeChartHeadline },
    },
  } = useTranslation()

  if (!products?.length) return null

  const firstSizeChart = products?.[0]?.productGroup.sizeChart ?? null

  const hasValidSizeChart = firstSizeChart !== null && firstSizeChart?.name !== 'null-size-chart'

  return (
    <Body>
      <HeaderWrapper>
        <TypeStyle.HeadlineSmall asTag='h2'>{headline}</TypeStyle.HeadlineSmall>
        {hasValidSizeChart && (
          <SizeChartButton
            onClick={() => firstSizeChart && openSizeChartModal(firstSizeChart)}
            {...trackEvent({
              category: bulkOrderCategory,
              action: 'view size chart',
              value: name,
            })}
          >
            {sizeChartHeadline}
          </SizeChartButton>
        )}
      </HeaderWrapper>
      <TilesList>
        {products?.map(product => (
          <CategoryProductTile isPlain={isPlain} product={product} key={product.id} />
        ))}
      </TilesList>
    </Body>
  )
}
